export const CANONICAL_HIERARCHY_RUN_METRIC_KEYS = {
  targetQueuedCount: "targetQueuedCount",
  targetCompletedCount: "targetCompletedCount",
  batchQueuedCount: "batchQueuedCount",
  batchCompletedCount: "batchCompletedCount",
  recommendationCount: "recommendationCount",
  synthesizedParentCount: "synthesizedParentCount",
} as const;

export type CanonicalHierarchyRunMetricKey =
  (typeof CANONICAL_HIERARCHY_RUN_METRIC_KEYS)[keyof typeof CANONICAL_HIERARCHY_RUN_METRIC_KEYS];

export const getCanonicalHierarchyRunMetricCount = (
  metrics: Record<string, number> | undefined,
  key: CanonicalHierarchyRunMetricKey,
): number => {
  const value = metrics?.[key];
  return Number.isFinite(value) ? Number(value) : 0;
};
